// src/logger.ts
const logBuffer: string[] = [];
const MAX_LOGS = 500; // Increased buffer size further

export const addLog = (msg: string) => {
  try {
    const timestamp = new Date().toISOString();
    const formattedMsg = `${timestamp} - ${msg}`;

    console.log(formattedMsg);
    logBuffer.push(formattedMsg);

    // Keep buffer size manageable
    if (logBuffer.length > MAX_LOGS) logBuffer.shift();
  } catch (error) {
    console.error("Error logging:", error);
  }
};

export const getLogs = () => [...logBuffer];

// Function to clear logs
export const clearLogs = () => {
  try {
    logBuffer.length = 0;
    console.log("Logs cleared");
  } catch (error) {
    console.error("Error clearing logs:", error);
  }
};

// Function to log device info
export const logDeviceInfo = () => {
  try {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;
    const vendor = navigator.vendor;
    const nav = navigator as Navigator & { deviceMemory?: number };
    const memory = nav.deviceMemory ? `${nav.deviceMemory}GB RAM` : "unknown RAM";
    const online = navigator.onLine ? "online" : "offline";

    addLog(`Device Info: ${platform}, ${userAgent}`);
    addLog(`Vendor: ${vendor}, Memory: ${memory}, Network: ${online}`);

    // Add screen dimensions which can be useful for debugging mobile issues
    addLog(
      `Screen: ${window.screen.width}x${window.screen.height}, Window: ${window.innerWidth}x${window.innerHeight}`
    );

    // Add device pixel ratio for high DPI screens
    addLog(`Device pixel ratio: ${window.devicePixelRatio}`);
  } catch (err) {
    addLog(
      `Error logging device info: ${
        err instanceof Error ? err.message : String(err)
      }`
    );
  }
};

// Function to log network info
export const logNetworkInfo = () => {
  try {
    addLog(`Network status: ${navigator.onLine ? "online" : "offline"}`);

    const connection = (navigator as Navigator & { connection?: { effectiveType?: string; downlink?: number; rtt?: number; saveData?: boolean } }).connection;
    if (connection) {
      addLog(
        `Network type: ${connection.effectiveType || "unknown"}, Downlink: ${
          connection.downlink || "unknown"
        }Mbps`
      );
      addLog(
        `RTT: ${connection.rtt || "unknown"}ms, Data saver: ${
          connection.saveData ? "on" : "off"
        }`
      );
    } else {
      addLog("Detailed network info not available");
    }

    // Ping the API to check connectivity
    /*  fetch('https://miningmatters.co/api/ping', { 
      method: 'GET',
      mode: 'no-cors',
      cache: 'no-cache'
    })
    .then(() => addLog('API server reachable'))
    .catch(err => addLog(`API server ping failed: ${err instanceof Error ? err.message : String(err)}`)); */
  } catch (err) {
    addLog(
      `Error logging network info: ${
        err instanceof Error ? err.message : String(err)
      }`
    );
  }
};

// Function to log API request details
export const logApiRequest = (
  method: string,
  url: string,
  headers?: Record<string, string>
) => {
  try {
    addLog(`API Request: ${method} ${url}`);
    if (headers) {
      const safeHeaders = { ...headers };
      // Redact sensitive headers
      if (safeHeaders.Authorization) {
        safeHeaders.Authorization =
          safeHeaders.Authorization.substring(0, 15) + "...";
      }
      addLog(`Request headers: ${JSON.stringify(safeHeaders)}`);
    }
  } catch (err) {
    addLog(
      `Error logging API request: ${
        err instanceof Error ? err.message : String(err)
      }`
    );
  }
};

// Add function to export logs as text file (useful for sharing logs)
export const exportLogs = (): string => {
  try {
    return logBuffer.join("\n");
  } catch (err) {
    console.error("Error exporting logs:", err);
    return "Error exporting logs";
  }
};
